module.exports = __webpack_public_path__ + "img/icon (3).72677779.png";